import React from "react";
import { useTranslation } from "react-i18next";
import NavMenu from "./NavMenu";
import "./Header.css";
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogoClick = () => {
        if (location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            navigate('/');
        }
    };

    const changeLanguage = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    return (
        <header className="header">
            <div className="header-content">
                <select
                    className="language-select"
                    value={i18n.language}
                    onChange={changeLanguage}
                >
                    <option value="de">DE</option>
                    <option value="en">EN</option>
                </select>

                <svg
                    viewBox="0 0 262.7 262.7"
                    preserveAspectRatio="xMidYMid meet"
                    className="menu-logo"
                    onClick={handleLogoClick}
                >
                    <g>
                        <path
                            stroke="#222"
                            strokeWidth="10"
                            strokeMiterlimit="10"
                            fill="#222"
                            d="m77.9 50.9-57.3 57.3 5 4.9 52.3-52.3 50.9 51v24.6H81.2v7.1h47.6v74.1L79.3 168H65.7v7h10.7l59.4 59.5v-91h38.1l-17.8 17.8-5 4.9 23.4 23.4 4.9-5-18.4-18.4 29.8-29.8h-55V112L187 60.9l52.2 52.2 4.9-4.9L187 51l-51.2 51.1V27.6h-7v74.2L77.9 50.9z"
                        />
                    </g>
                </svg>

                <NavMenu />
            </div>
        </header>
    );
};

export default Header;
